<template>
  <app-modal
    v-bind="$attrs"
    title="確認"
    ref="modal"
    class="modal-container"
    content-class="modal-full"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text class="pa-4">
        <div class="modal-body">
          <v-container fluid class="pa-0">
            <div class="font-weight-bold mb-3">
              本ルールを保存します。よろしいですか？
            </div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>宛先アドレス</th>
                  <th>サービス</th>
                  <th>プロファイル</th>
                  <th>アクション</th>
                  <th>ログ出力</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ policy.policyId }}</td>
                  <td>
                    <policy-src-address :src-address="policy.srcAddress" />
                  </td>
                  <td>
                    <policy-dst-address :dst-address="policy.dstAddress" />
                  </td>
                  <td>
                    <policy-service
                      :service-option="policy.serviceOption"
                      :default-service-list="policy.defaultServiceList"
                      :custom-service-list="policy.customServiceList"
                    />
                  </td>
                  <td>
                    <policy-profile :profile="policy.profile" />
                  </td>
                  <td>
                    {{ $filter.enumTo(policy.actionType, "allow_deny") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(policy.isLogOutput, "on_off") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(policy.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(policy.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
            <v-btn color="primary" variant="outlined" @click="cancel">
              いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import PolicyProfile from "@/components/policy/PolicyProfile.vue";
import PolicyService from "@/components/policy/PolicyService.vue";
import PolicyDstAddress from "@/components/policy/PolicyDstAddress.vue";
import PolicySrcAddress from "@/components/policy/PolicySrcAddress.vue";
import type { Type4IFWPolicy } from "@/modals/applianceContractSetting/type4/policy/ifw/InternetType4PolicyRuleIfwViewRD.vue";

export default defineComponent({
  name: "InternetType4PolicyRuleIfwConfirm",
  components: {
    PolicyProfile,
    PolicyService,
    PolicyDstAddress,
    PolicySrcAddress,
  },
  props: {
    /** ポリシー */
    policy: {
      type: Object as PropType<Type4IFWPolicy>,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
th {
  text-align: center !important;
}
</style>
